module.exports = __webpack_public_path__ + "media/images/bgfaq-cb04ebe0ce1be6b41790aeef4a422994.png";